import { redirectWithSsoHandoff } from './ssoHandoff';

const DEFAULT_DAYCARE_APP_URL = 'https://tinywins-daycare.d2r0nn56b430oe.amplifyapp.com';

/** Base URL for the tinywins-daycare Amplify app (no trailing slash). */
export function getTinywinsDaycareAppUrl(): string {
  const raw =
    import.meta.env.VITE_TINYWINS_DAYCARE_APP_URL?.trim() ||
    import.meta.env.VITE_TINYWINS_SCHOOL_APP_URL?.trim() ||
    DEFAULT_DAYCARE_APP_URL;
  return raw.replace(/\/+$/, '');
}

/** Temporary test gate: CLINICIAN users go to tinywins-daycare instead of tinywins-dev. */
export function shouldRedirectClinicianToDaycare(role: string | null | undefined): boolean {
  return role === 'CLINICIAN';
}

/** Pass the active Cognito session to daycare via URL hash (not sent to servers). */
export async function redirectClinicianToDaycareApp(): Promise<void> {
  await redirectWithSsoHandoff(getTinywinsDaycareAppUrl());
}
